/* eslint no-use-before-define: ["error", { "functions": false }] */
import {TRAVEL_MODES, COLORS} from './constants'

function stepColor(step, params = {}) {
  switch (step.travel_mode) {
    case TRAVEL_MODES.WALKING:
      return COLORS.WALKING
    case TRAVEL_MODES.TRANSIT:
      return transitColor(step, params)
    default:
      return COLORS.DEFAULT
  }
}

function transitColor(step, params) {
  const options = {
    acceptWhite: true,
    ...params
  }

  let color = _.get(step, 'transit.line.color')

  if (!options.acceptWhite) {
    if (!color || isWhite(color)) {
      color = COLORS.DEFAULT
    }
  }

  return color || COLORS.DEFAULT
}

function stepTextColor(step) {
  return _.get(step, 'transit.line.text_color') || COLORS.WHITE
}

function isWhite(color) {
  const r = parseInt(color.substr(1, 2), 16)
  const g = parseInt(color.substr(3, 2), 16)
  const b = parseInt(color.substr(5, 2), 16)
  const hexColor = ((r * 299) + (g * 587) + (b * 114)) / 1000
  return hexColor >= 252
}

export {
  stepColor,
  stepTextColor
}
